import { useState } from 'react';
import {
  Button,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';

import {
  massUploadApplicantsCSV,
  uploadManagersCSV,
  uploadSectionsCSV,
} from 'api';
import messages from 'messages';
import { SnackbarVariant } from '../../constants';
import ValidationErrors from './ValidationErrors.js';

function FileInput({ accept, onChange }) {
  return <input hidden type={'file'} accept={accept} onChange={onChange} />;
}

function SubmitButton({ onClick, label }) {
  return (
    <Button onClick={onClick} variant="string">
      {label}
    </Button>
  );
}

function SendButtons({ children }) {
  return <ButtonGroup>{children}</ButtonGroup>;
}

export default function CsvImport({
  handleClose,
  uploadType,
  updateListCallback,
  sectionId,
  section,
}) {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [file, setFile] = useState();
  const [errors, setErrors] = useState();
  const [sendApplications, setSendApplications] = useState(false);

  const externalType =
    section && section[0] && section[0].externalType
      ? section[0].externalType
      : '';

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCheckChange = (e) => {
    setSendApplications(e.target.checked);
  };

  const handleOnSubmit = (e, uploadFunction) => {
    e.preventDefault();
    if (file) {
      uploadFunction(file)
        .then(() => {
          enqueueSnackbar(intl.formatMessage(messages.general_save_success), {
            variant: SnackbarVariant.SUCCESS,
          });
          updateListCallback();
          handleClose();
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              error.response.data && setErrors(error.response.data);
            }
            if (error.response.status === 409) {
              enqueueSnackbar(
                intl.formatMessage(messages.csv_import_error_exists),
                {
                  variant: SnackbarVariant.ERROR,
                }
              );
            } else if (
              error.response.status === 400 ||
              error.response.status === 404
            ) {
              enqueueSnackbar(
                intl.formatMessage(messages.csv_import_error_check_csv, {
                  errorMessage: error.response.data.message,
                }),
                {
                  variant: SnackbarVariant.ERROR,
                  autoHideDuration: 10000,
                }
              );
            } else {
              enqueueSnackbar(
                intl.formatMessage(messages.csv_import_error_generic),
                {
                  variant: SnackbarVariant.ERROR,
                }
              );
            }
          }
        });
    }
  };

  return (
    <>
      <div style={{ textAlign: 'center', paddingBottom: '2rem' }}>
        <h1>{intl.formatMessage(messages.import_csv)}</h1>
        <form>
          <Grid container spacing={3}>
            {uploadType === 'applicant' && externalType.includes('5') && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendApplications}
                      onChange={handleCheckChange}
                      color="primary"
                    />
                  }
                  label={intl.formatMessage(
                    messages.csv_import_send_applications
                  )}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <SendButtons>
                <Button variant="contained" component="label">
                  <FormattedMessage defaultMessage="Lisää tiedosto" />
                  <FileInput accept={'.csv'} onChange={handleOnChange} />
                </Button>

                {uploadType === 'section' && (
                  <SubmitButton
                    onClick={(e) => {
                      handleOnSubmit(e, uploadSectionsCSV);
                    }}
                    label={intl.formatMessage(messages.send)}
                  />
                )}

                {uploadType === 'manager' && (
                  <SubmitButton
                    onClick={(e) => {
                      handleOnSubmit(e, uploadManagersCSV);
                    }}
                    label={intl.formatMessage(messages.send)}
                  />
                )}
                {uploadType === 'applicant' && (
                  <>
                    <SubmitButton
                      onClick={(e) => {
                        handleOnSubmit(e, (file) =>
                          massUploadApplicantsCSV(
                            file,
                            sectionId,
                            sendApplications
                          )
                        );
                      }}
                      label={intl.formatMessage(messages.send)}
                    />
                  </>
                )}
              </SendButtons>
            </Grid>
          </Grid>
        </form>
        {file && <h4>Tiedosto: {file.name}</h4>}
      </div>
      <ValidationErrors errors={errors} />
      <Button onClick={handleClose} color="primary">
        {intl.formatMessage(messages.back)}
      </Button>
    </>
  );
}
